//? PLUGINS //
import { Box, Button, Card, CircularProgress, Container, useTheme } from "@mui/material";
import MultiStepForm, {
    FormStep,
} from "components/formsUI/Stepper/multiStepForm";
import FirstStepIndividual, {
    FORM_VALIDATION,
    INITIAL_FORM_STATE,
} from "pages/requests/stepsIndividual/step1/step1";
import SecondStepIndividual, {
    FORM_VALIDATION_STEP2,
    INITIAL_FORM_STATE_STEP2,
} from "pages/requests/stepsIndividual/step2/step2";
import ThirdStepIndividual, {
    FORM_VALIDATION_STEP3,
    INITIAL_FORM_STATE_STEP3,
} from "pages/requests/stepsIndividual/step3/step3";
import FourthStepIndividual from "pages/requests/stepsIndividual/step4/step4";
import * as applicationService from "services/application-service";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { completeApplicationAsync } from "services/application-service";
import * as Styles from "pages/requests/stepsIndividual/submitted/submitted.styes";

// import * as Yup from 'yup';
import { FormikValues } from "formik";
import { INITIAL_FORM_STATE_STEP4 } from "./stepsIndividual/step4/step4.content";
import { AxiosError } from "axios";
import countries from "resources/countries_en_nl.json";
import { useTenantContext } from "contexts/tenantContext";
import { deepEquals } from 'utilities/equalChecker'
import i18next from "i18next";

//? COMPONENTS //
//? EXTRA //
// import { FormStep } from 'components/formsUI/Stepper/multiStepForm';

let initial_values = {
    ...INITIAL_FORM_STATE,
    ...INITIAL_FORM_STATE_STEP2,
    ...INITIAL_FORM_STATE_STEP3,
    ...INITIAL_FORM_STATE_STEP4,
};

const disable_validation = false;

const validationSchema = (t: any, step: Number, titlePath: string) => {
    switch (step) {
        case 0:
            return disable_validation ? null : FORM_VALIDATION(t);
        case 1:
            return disable_validation ? null : FORM_VALIDATION_STEP2(t);
        case 2:
            return disable_validation ? null : FORM_VALIDATION_STEP3(t, titlePath);
        default:
            return null;
    }
};

interface AanvraagProps {
    showMessage: MessageBox;
    titlePath: string;
}

const AanvraagVeiligheidsVerificatieIndienen = (props: AanvraagProps) => {
    const locale = i18next.language === undefined ? "nl" : i18next.language;
    // TODO : add option to remove timer in Message
    const theme = useTheme();
    const { showMessage, titlePath } = props;
    const { applicationId, completionHash, step } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const childRef: any = React.createRef();
    const [loading, setLoading] = React.useState<boolean>(true);
    const [error, setError] = React.useState<{ is: boolean, message: string }>({ is: false, message: '' });
    const { currentTenant, setTenantByZoneNum } = useTenantContext();
    const [searchParams] = useSearchParams();

    React.useEffect(() => {
        // console.log(currentTenant)
        if (completionHash !== null && completionHash !== undefined && applicationId !== null && applicationId !== undefined) {
            const zoneName = searchParams.get('zoneId');
            if (currentTenant === null && zoneName === null && zoneName === undefined) {
              setTenantByZoneNum('5345')
            }
            if ((titlePath === 'requestAll.title' || titlePath === 'requestAll.completeTitle') && currentTenant !== null) {
                applicationService.getApplicationByIdAndHash(applicationId, completionHash).then(res => {
                    setError({ is: false, message: '' });
                    if (res !== undefined) {
                        const birthday = res.applicant.birthDay?.toString() === '0001-01-01T00:00:00' ? '' : res.applicant.birthDay?.toString();
                        var country = null;
                        const countriesFound = countries.filter((country) => country.name.nl === res.applicant?.address?.country || 
                            country.name.en === res.applicant?.address?.country || 
                            country.name.fr === res.applicant?.address?.country);
                        if (countriesFound.length !== 0) {
                            if (locale === 'en') country = countriesFound[0].name.en;
                            else if (locale === 'fr') country = countriesFound[0].name.fr;
                            else country = countriesFound[0].name.nl;
                        }

                        var nationality = null;
                        const nationalitiesFound = countries.filter((country) => country.nationality?.nl === res.applicant?.nationality || 
                        country.nationality?.en === res.applicant?.nationality || 
                        country.nationality?.fr === res.applicant?.nationality);
                        if (nationalitiesFound.length !== 0) {
                            if (locale === 'en') nationality = nationalitiesFound[0].nationality?.en;
                            else if (locale === 'fr') nationality = nationalitiesFound[0].nationality?.fr;
                            else nationality = nationalitiesFound[0].nationality?.nl;
                        }

                        res.applicant.address.country = country ?? '';
                        res.applicant.nationality = nationality ?? '';

                        // TODO: convert to formatter
                        initial_values = {
                            userFirstName: res.applicant?.firstName,
                            userLastName: res.applicant?.lastName,
                            userBirthDay: birthday,
                            userNationality: res.applicant?.nationality,
                            userBirthPlace: res.applicant?.birthPlace,
                            userAddressBox: res.applicant?.address?.box,
                            userAddressCity: res.applicant?.address?.city,
                            userAddressCountry: res.applicant?.address?.country,
                            userAddressHouseNumber: res.applicant?.address?.houseNumber,
                            userAddressStreet: res.applicant?.address?.street,
                            userAddressZip: res.applicant?.address?.zip,
                            userEmail: res.applicant?.email,
                            userRRN: res.applicant?.rrn,
                            companyName: res.responsible?.company?.name,
                            companyResponsibleFirstName: res.responsible?.firstName,
                            companyResponsibleLastName: res.responsible?.lastName,
                            companyResponsibleEmail: res.responsible?.email,
                            dateFrom: res.dateFrom?.toString(),
                            dateTo: res.dateTo?.toString(),
                            zone: '',
                            locations: res?.locations?.map(loc => loc.name),
                            reason: res.reason,
                            function: res.function,
                            fileUpload: res.attachments?.filter(a => a.isEditable === false).map(attachement => {
                                const type = attachement.type.split('/');
                                return {
                                    id: attachement.applicationId as string,
                                    file: new File(new Array<BlobPart>(attachement.size), attachement.name, { type: attachement.type }),
                                    progress: 100,
                                    extension: type[type.length - 1],
                                    dbId: attachement.id,
                                };
                            })
                        }
                        setLoading(false)
                    }
                }).catch((err) => {
                    const {
                        response: {
                            data: {
                                error: {
                                    message
                                }
                            }
                        }
                    } = err;
                    setLoading(false)
                    setError({ is: true, message: message })
                });
            }
        } else {
            ;
            initial_values = {
                ...INITIAL_FORM_STATE,
                ...INITIAL_FORM_STATE_STEP2,
                ...INITIAL_FORM_STATE_STEP3,
                ...INITIAL_FORM_STATE_STEP4,
            }
            setLoading(false)
        }
    }, [setLoading, completionHash, applicationId, currentTenant])

    const steps = [
        t("steps.step1"),
        t("steps.step2"),
        t("steps.step3"),
        t("steps.step4"),
        t("steps.step5"),
    ];

    const renderStepContent = (step: number) => {
        switch (step) {
            case 0:
                return (
                    <FirstStepIndividual
                        title={steps[0]}
                        onBackClick={() => {
                            childRef.current.callPrevious();
                        }}
                        titlePath={titlePath}
                    />
                );
            case 1:
                return (
                    <SecondStepIndividual
                        title={steps[1]}
                        onBackClick={() => {
                            childRef.current.callPrevious();
                        }}
                    />
                );
            case 2:
                return (
                    <ThirdStepIndividual
                        title={steps[2]}
                        onBackClick={() => {
                            childRef.current.callPrevious();
                        }}
                        titlePath={titlePath}
                    />
                );
            case 3:
                return (
                    <FourthStepIndividual
                        title={steps[3]}
                        onBackClick={() => {
                            childRef.current.callPrevious();
                        }}
                        showMessage={showMessage}
                    />
                );
            // case 4:
            //   // TODO : Add document
            //   return (
            //     <FifthStepIndividual
            //       title={steps[4]}
            //       onBackClick={() => {
            //         childRef.current.callPrevious();
            //       }}
            //     />
            //   );
        }
    };

    const handleStepInit = () => {
        if (step !== undefined) {
            return parseInt(step);
        }
        return undefined
    }

    const [errorSubmit, setErrorSubmit] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [loadingSubmit, setLoadingSubmit] = React.useState(false);

    const handleGoHome = () => {
        navigate('/');
    }

    const handleSubmit = async (values: FormikValues) => {
        // const dossierId = localStorage.getItem('dossierId') as string;
        // TODO : Enable to send info to backend
        console.log(values, initial_values, titlePath, !deepEquals(values, initial_values))
        if (!deepEquals(values, initial_values) || titlePath === 'requestAll.completeTitle') {
            await completeApplicationAsync({
                applicationId: applicationId,
                isDevRequest: false,
                values: values,
                completionHash: completionHash
            })
                .then(() => {
                    if (titlePath === 'requestAll.title' || titlePath === 'requestAll.completeTitle') {
                        navigate(`/finalize/${applicationId}/${completionHash}`, { state: steps });
                    } else {
                        navigate(`/finalize/${applicationId}`, { state: steps });
                    }
                })
                .catch((err) => { });
        } else {
            console.log('only updates files');
            if (!loadingSubmit) {
                setErrorMessage("");
                setErrorSubmit(false);
                setLoadingSubmit(true);
                applicationService.finishApplicationAsync(applicationId as string)
                    .then((res: void) => {
                        navigate("/aanvraag_veiligheidsverificatie_ingediend");
                        setLoadingSubmit(false);
                    })
                    .catch((error: AxiosError<Error>) => {
                        setErrorSubmit(true);
                        setErrorMessage(`${t("requestIndividual.step5.errorUpdating")}`);
                        setLoadingSubmit(false);
                    });
            }
        }
    }

    return (
        // <Grid container>
        <Container maxWidth="lg" sx={{ zIndex: "1", p: 0 }}>
            {/* <h1>Aanvraag veiligheidsverificatie indienen</h1>
				<br /> */}

            {!loading && !error.is ?
                <Box>
                    <MultiStepForm
                        ref={childRef}
                        initialValues={initial_values}
                        onSubmit={handleSubmit}
                        stepInit={handleStepInit()}
                    >
                        {steps.map((step, index) => (
                            <FormStep
                                key={index}
                                stepName={step}
                                // onSubmit={() => console.log(`${step} submit`)}
                                validationSchema={validationSchema(t, index, titlePath)}
                            >
                                {renderStepContent(index)}
                            </FormStep>
                        ))}
                    </MultiStepForm>
                    <Box sx={{ textAlign: "center", position: "absolute", margin: "0", padding: "0", left: "0", right: "0", marginTop: "-70px" }}>
                        {loadingSubmit && <CircularProgress sx={{ marginTop: "-25px" }} />}
                        {errorSubmit && <Box color="error.main" marginTop="-5px">{errorMessage}</Box>}
                    </Box>

                </Box> : error.is ?
                    <Box maxWidth="lg" sx={Styles.wrapper(theme)}>
                        <Card sx={Styles.cardCSS(theme)}>
                            <Box sx={Styles.containerCSS(theme)}>
                                <h1>{t("requestIndividual.step5.errorTitle")}</h1>
                                <Box sx={Styles.infotext(theme)}>
                                    {t(error.message)}
                                </Box>
                                <Button onClick={handleGoHome} sx={{ marginTop: '1.50rem' }} variant='contained'>{t('requestIndividual.step5.return')}</Button>
                            </Box>
                        </Card>
                    </Box> :
                    <Box sx={{ width: "100%", textAlign: "center" }}><CircularProgress /></Box>
            }
            <br />
        </Container>
        // </Grid>
    );
};

export default AanvraagVeiligheidsVerificatieIndienen;
